import { render, staticRenderFns } from "./AddTransaction.vue?vue&type=template&id=0fae8fb8&scoped=true&"
import script from "./AddTransaction.vue?vue&type=script&lang=js&"
export * from "./AddTransaction.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae8fb8",
  null
  
)

export default component.exports